@if (isLoading()) {
  <lib-tile-loader @fadeOut [count]="focusMeasures().length"/>
} @else {
  @if (dataChunk(); as chunk) {
    <lib-cubes-manager
      data-test="kpi-grid"
      [dataModel]="focusMeasures()"
    >
      <lib-cube
        class="tile"
        data-test="tile"
        *cubeTemplate="focusMeasures(); let measure"
      >
        @let focusDataPoint = chunk.dataPoints | selectDataPoint: measure.code : periodCode() : date();
        @let growthDataPoint = chunk.dataPoints | selectDataPoint: measure.impactMeasureCode : periodCode() : date();

        <ng-template #header>
          <lib-tile-header [title]="measure.shortName"/>
        </ng-template>

        <div
          *libCubeFace
          class="tile-face"
          [attr.data-sentiment]="Sentiment.Neutral"
        >
          <header class="tile-header">
            <ng-template [ngTemplateOutlet]="header"/>
            <lib-direction-indicator [value]="focusDataPoint?.sentiment"/>
          </header>

          <lib-featured-value
            [value]="focusDataPoint?.value"
            [measure]="measure"
            [growthValue]="growthDataPoint?.value"
            [growthMeasure]="measure.impactMeasure"
            [growthMeasureLabel]="growthMeasureLabel()"
          />

          <lib-l12m-bar-chart
            [dataPoints]="chunk.dataPoints"
            [growthMeasure]="measure.impactMeasure"
            [period]="periodCode()"
            [date]="date()"
            [title]="measure.shortName + ' change vs previous year'"
          />
        </div>

        <div
          *libCubeFace
          class="tile-face"
          [attr.data-sentiment]="focusDataPoint?.sentiment"
        >
          <ng-template [ngTemplateOutlet]="header"/>

          @if (topPerspective(); as perspective) {
            <lib-report-button
              [perspective]="perspective"
              [options]="{
              focusMeasure: measure,
              focusPeriod: periodCode()
            }"
              [reportPath]="reportPath()"
              />
          }

          <lib-drilldown
            [dimensionItems]="chunk.dimensionItems"
            (drillDown)="handleDrilldown($event, measure)"
          />
        </div>
      </lib-cube>
    </lib-cubes-manager>
  }
}
